// extracted by mini-css-extract-plugin
export default {"container":"PlaceHTMLOnMap--container--dSNVS","allowPointerEvents":"PlaceHTMLOnMap--allowPointerEvents--lFChO"};